import {
  PROFILE_UPLOAD_AVATAR_BEGIN,
  PROFILE_UPLOAD_AVATAR_SUCCESS,
  PROFILE_UPLOAD_AVATAR_FAILURE,
  PROFILE_UPLOAD_AVATAR_DISMISS_ERROR,
} from './constants';
import {SERVER_PATH, AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function uploadAvatar(file) {
  file.user=localStorage.getItem("user_id")
  let archivo = new FormData();
  archivo.append('file', file);
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PROFILE_UPLOAD_AVATAR_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let urlPost = SERVER_PATH + '/profileAvatar/uploadAvatar';
      const doRequest = axios.post(urlPost, archivo, AXIOS_CONFIG());
      doRequest.then(
        (res) => {
          dispatch({
            type: PROFILE_UPLOAD_AVATAR_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PROFILE_UPLOAD_AVATAR_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissUploadAvatarError() {
  return {
    type: PROFILE_UPLOAD_AVATAR_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROFILE_UPLOAD_AVATAR_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        uploadAvatarPending: true,
        uploadAvatarError: null,
      };

    case PROFILE_UPLOAD_AVATAR_SUCCESS:
      // The request is success
      localStorage.setItem("avatar",action.data.data.avatar)
      return {
        ...state,
        uploadAvatarPending: false,
        uploadAvatarError: null,
      };

    case PROFILE_UPLOAD_AVATAR_FAILURE:
      // The request is failed
      return {
        ...state,
        uploadAvatarPending: false,
        uploadAvatarError: action.data.error,
      };

    case PROFILE_UPLOAD_AVATAR_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        uploadAvatarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/profile/redux/uploadAvatar.js